import { useSnackbar } from "notistack";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MCLabel, MCTooltip } from "../../../MainComponents";
import Icon from "../../../Icon/Icon";

const PasswordComponent = ({ password }) => {
  const [t] = useTranslation("exports");
  const { enqueueSnackbar } = useSnackbar();
  // This state is used to show the password
  const [showPassword, setShowPassword] = useState(false);

  const fnCopyOnClipboard = () => {
    navigator.clipboard.writeText(password);
    enqueueSnackbar(t("Exports.copied"), { variant: "info" });
  };

  return (
    <>
      <MCLabel text={`${t("Exports.password")}:`} className="labels mb-1" />
      <div className="password-container">
        <MCTooltip position="bottom" text={t("Exports.copy_password")}>
          <div className="password" onClick={fnCopyOnClipboard}>
            <span>{showPassword ? password : "********"}</span>
          </div>
        </MCTooltip>
        <div className={`password-icon-eye ${showPassword ? "show" : ""}`}>
          <Icon
            name={showPassword ? "outline_eye_slash" : "outline_eye"}
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>
      </div>
    </>
  );
};

export default PasswordComponent;